import { selectTotalCategories } from '../../../api';
import { useHeaderData } from '../../../hooks';
import { CategoryLink } from '../../CategoryLink';

export function MenuMobileNavBar() {
  const data = useHeaderData();
  const totalCategories = selectTotalCategories(data);

  return (
    <nav className="tlw-border-b tlw-border-b-sec-sup-light tlw-overflow-hidden">
      <ul className="tlw-px-4 tlw-flex tlw-gap-2 tlw-overflow-x-auto tlw-scrollbar-none">
        {totalCategories.map((item) => (
          <li key={item.title}>
            <CategoryLink category={item} />
          </li>
        ))}
      </ul>
    </nav>
  );
}
